import Chip from '@/components/ui/Chip';
import type { ChipProps } from '@/components/ui/Chip';
import type { TransactionDetail } from '@/types';

type OfacStatusValue = NonNullable<TransactionDetail['ofac_state']>['status'];

type Props = {
  status?: OfacStatusValue;
};

const COLORS = {
  matched: 'error',
  cleared: 'success',
  pending: 'warning',
} as const;

const LABELS = {
  matched: 'Matched',
  cleared: 'No matches',
  pending: 'Pending',
} as const;

/**
 * Resolves an OFAC status into a pill color + label. Unknown/undefined — a sale
 * that was never OFAC-gated — falls back to a grey "N/A".
 */
export const resolveOfacStatus = (
  status?: OfacStatusValue,
): { color: ChipProps['color']; label: string } => ({
  color: (status && COLORS[status]) || 'default',
  label: (status && LABELS[status]) || 'N/A',
});

/**
 * OFAC match pill for the sale details drawer. Renders a colored pill for the
 * sale's OFAC status; a grey "N/A" when the sale was never OFAC-gated (null).
 */
const OfacStatus = ({ status }: Props) => {
  const { color, label } = resolveOfacStatus(status);

  return (
    <Chip
      data-test="sale-ofac-status"
      color={color}
      label={label}
      sx={{ mx: 'auto', fontWeight: 'bold', fontSize: '12px' }}
    />
  );
};

export default OfacStatus;
